import '../styles/application.scss';

import './globals.js';
import $ from 'jquery';
import attachFastClick from 'fastclick';
import 'lazysizes';
import svg4everybody from 'svg4everybody';

import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

import './app.js';

// Modules
import './modules/ScrollNav.js';
import './modules/MobileNav.js';
import './modules/InkModal.js';

// Sections
import './sections/SiteBackground.js';
import './sections/Hero.js';
import './sections/NeonRentals.js';
import './sections/CustomWork.js';
import './sections/HowNeonWorks.js';
import './sections/Press.js';
import './sections/Quote.js';
import './sections/AboutModalContent.js';
import Orbit from './modules/Orbit.js';

attachFastClick(document.body);
svg4everybody();

new Orbit({ selector: '#QuoteOrbit' });
new Orbit({ selector: '#AboutOrbit' });
new Orbit({
	selector: '#HowNeonWorksOrbit',
	onAnimateInComplete: function () {
		$('#HowNeonWorks').addClass('is-active');
	},
});

// PhotoSwipe (the jQuery wrapper reads these from window)
window.PhotoSwipe = PhotoSwipe;
window.PhotoSwipeUI_Default = PhotoSwipeUI_Default;
await import('./plugins/jquery.photoswipe.js');

$('.js-photoswipe').photoswipe();

if (import.meta.hot) {
	import.meta.hot.accept();
}
